import WheelSpinner from "./WheelSpinner";

export default function AppLoading(params) {
    return (
        <div className="flex items-center justify-center mt-64 ">
            <WheelSpinner size="64" />
        </div>
    );
}
